import { render } from "./PatientListItem.vue?vue&type=template&id=6aa247ed"
import script from "./PatientListItem.vue?vue&type=script&lang=js"
export * from "./PatientListItem.vue?vue&type=script&lang=js"

import "./PatientListItem.vue?vue&type=style&index=0&id=6aa247ed&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__